module.exports = __webpack_public_path__ + "static/media/india.efff0ed6.png";